import { InputAdornment, TextField } from '@mui/material';
import { SearchRounded } from '@mui/icons-material';
import React, { useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';
import useCoursesTeacher from '../../../../hooks/useCoursesTeacher';
import CourseCardRounded from '../../../common/CourseCardRounded';
import ErrorResponse from '../../../common/ErrorResponse';
import GridCard from '../../../common/GridCard';
import NoResultsFound from '../../../common/NoResultsFound';
import SimpleLoading from '../../../common/SimpleLoading';
import SplitButton from '../../../common/SplitButton';

const GridCoursesTeacher = ({ filteredCourses }) => {
    const options = ['Por defecto', 'Más antiguo', 'Más nuevo'];
    // eslint-disable-next-line no-unused-vars
    const [currentFilter, setCurrentFilter] = useState({
        index: 0,
        name: 'Por defecto',
    });
    const [filterField, setFilterField] = useState('');

    const {
        initialCourses,
        courses: coursesFromHook,
        handleCourses,
    } = useCoursesTeacher();

    const isUsingFilteredProp = filteredCourses !== undefined;

    const [displayCourses, setDisplayCourses] = useState(
        Array.isArray(filteredCourses) ? filteredCourses : []
    );
    const [sourceCourses, setSourceCourses] = useState(
        Array.isArray(filteredCourses) ? filteredCourses : []
    );

    const courses = useMemo(() => {
        if (isUsingFilteredProp) {
            return displayCourses;
        }
        return coursesFromHook;
    }, [isUsingFilteredProp, displayCourses, coursesFromHook]);

    useEffect(() => {
        if (Array.isArray(filteredCourses)) {
            setDisplayCourses(filteredCourses);
            setSourceCourses(filteredCourses);
        }
    }, [filteredCourses]);

    const handleOption = (args) => {
        setCurrentFilter(args);

        if (isUsingFilteredProp) {
            const sorted = [...displayCourses];
            if (args.index === 0) {
                sorted.sort((a, b) => a.id - b.id);
            } else if (args.index === 1) {
                sorted.sort(
                    (a, b) =>
                        new Date(a.fecha_deadline) - new Date(b.fecha_deadline)
                );
            } else if (args.index === 2) {
                sorted.sort(
                    (a, b) =>
                        new Date(b.fecha_deadline) - new Date(a.fecha_deadline)
                );
            }
            setDisplayCourses(sorted);
        } else {
            args.index === 0 &&
                handleCourses(coursesFromHook.sort((a, b) => a.id > b.id));
            args.index === 1 &&
                handleCourses(
                    coursesFromHook.sort(
                        (a, b) => a.fecha_deadline > b.fecha_deadline
                    )
                );
            args.index === 2 &&
                handleCourses(
                    coursesFromHook.sort(
                        (a, b) => a.fecha_deadline < b.fecha_deadline
                    )
                );
        }
    };

    const handleChange = (e) => {
        const { value } = e.target;
        setFilterField(value);

        if (isUsingFilteredProp) {
            const filtered = sourceCourses.filter((course) =>
                course.name.toLowerCase().includes(value.toLowerCase())
            );
            setDisplayCourses(filtered);
        } else {
            handleCourses(
                initialCourses.filter((course) =>
                    course.name.toLowerCase().includes(value.toLowerCase())
                )
            );
        }
    };

    if (courses === false) {
        return (
            <GridTeacherWrapper>
                <ErrorResponse />
            </GridTeacherWrapper>
        );
    }

    if (isUsingFilteredProp && filteredCourses === null) {
        return (
            <GridTeacherWrapper>
                <SimpleLoading />
            </GridTeacherWrapper>
        );
    }

    if (courses === null) {
        return (
            <GridTeacherWrapper>
                <SimpleLoading />
            </GridTeacherWrapper>
        );
    }

    return (
        <GridTeacherWrapper>
            <Header>
                <TextField
                    value={filterField}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    label="Buscar curso..."
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchRounded />
                            </InputAdornment>
                        ),
                    }}
                />
                <SplitButton handleOption={handleOption} options={options} />
            </Header>
            <GridCard
                cards={courses}
                component={CourseCardRounded}
                display="grid"
            />
            {courses.length === 0 && <NoResultsFound />}
        </GridTeacherWrapper>
    );
};

export default GridCoursesTeacher;

const GridTeacherWrapper = styled.div``;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 16px;
`;
